<template>
  <section class="px-5 pb-5">
    <CCol v-if="messages.length" sm="12" class="mt-3">
      <transition name="fade">
        <MenssageAlert :messages="messages" />
      </transition>
    </CCol>
    <CAlert class="mt-5 ml-5 mr-5 mb-0 font-sm" color="info">
      <div class="d-flex align-items-baseline text-black">
        <div>
          <CIcon name="infoCircle" size="custom-size" class="mr-2" :height="15" style="transform: rotate(180deg)" viewBox="0 0 32 32" />
        </div>
        <p class="mb-0">
          {{ $t('manageplan.component.card.payment-method-alert') }}
        </p>
      </div>
    </CAlert>
    <CForm role="group" class="form-group mb-3 px-5 mt-5">
      <p class="mb-4 font-weight-bold">
        <CIcon name="creditCard" class="mx-1" size="custom-size" :height="25" viewBox="0 0 32 32" />
        {{ $t(`manageplan.component.card.payment-method-subtitle`) }}
      </p>

      <div class="mb-2" v-if="customer.card">
        <label>
          {{ $t(`manageplan.component.card.payment-method-label`) }}
        </label>

        <v-select
          v-model="selectedPayment"
          class="selectCountry newInput no-close mb-0 px-3"
          :options="options"
          ref="countrySelect"
          custom
          autoscroll
          placeholder="SelectedPayment method"
          @input="selectMethod"
        >
          <template #selected-option="option">
            <div class="d-flex align-items-center align-self-center">
              <CIcon :name="option.brand" size="custom-size" :height="30" viewBox="0 0 32 32" />
              <span class="ml-2">
                {{ option.label }}
              </span>
            </div>
          </template>
          <template v-slot:option="option">
            <div class="py-4 px-2 d-flex justify-content-between">
              <CIcon :name="option.brand" size="custom-size" :height="30" viewBox="0 0 32 32" />
              <span class="ml-2">
                {{ option.label }}
              </span>
              <span class="ml-2" v-if="option.expMonth"> {{ option.expMonth }} / {{ option.expYear }} </span>
            </div>
          </template>
        </v-select>
      </div>
      <div v-if="selectedPayment && selectedPayment.iframe">
        <CInput
          type="text"
          class="newInput nameCard"
          :class="{ error: hasErrorName }"
          :label="$t('manageplan.component.card.payment-method.label.name')"
          aria-placeholder="name"
          :placeholder="$t('manageplan.component.card.payment-method.placeholder.name')"
          v-model="name"
          :add-input-classes="{ error: hasErrorName }"
          ref="inputName"
          @focus="focus"
        />
        <p class="p-0" v-if="hasErrorName" :class="{ error: hasErrorName }" role="alert">
          {{ $t('manageplan.component.card.payment-method.message-error-nameCard') }}
        </p>
      </div>
    </CForm>
    <div ref="card" class="px-5"></div>

    <div class="d-flex justify-content-end px-5 mt-3">
      <CButton class="font-base btn btn-outline-light text-gray-600 px-5 py-3" @click="prev">
        {{ $t('manageplan.component.card.payment-method.button.back') }}
      </CButton>
      <CButton color="primary" class="font-base ml-3 px-5 py-3" @click="submit" :disabled="!selectedPayment || loading">
        <span class="px-5">
          {{ $t('manageplan.component.card.payment-method.button.next') }}
        </span>
      </CButton>
    </div>
  </section>
</template>

<script>
import vSelect from 'vue-select'
import MenssageAlert from '@/components/MenssageAlert'
import services from '@/services.js'

export default {
  components: {
    vSelect,
    MenssageAlert,
  },
  data() {
    return {
      stripe: null,
      elements: null,
      card: null,
      organizationId: null,
      host: window.location.host,
      protocol: window.location.protocol,
      appearance: {
        theme: 'stripe',

        rules: {
          '.Label': {
            fontSize: '1rem',
            fontWeight: 'semibold',
          },
        },

        variables: {
          colorPrimary: '#0570de',
          colorBackground: '#ffffff',
          colorText: '#30313d',
          colorDanger: '#df1b41',
          fontFamily: 'Nunito Sans, system-ui, sans-serif',
          spacingUnit: '6px',
          borderRadius: '4px',
        },
      },
      path: this.$route.path,
      selectedPayment: this.$store.state.backOffice.steps.selectPayment || null,
      billingInfo: null,
      customer: null,
      planId: this.$store.state.backOffice.steps.selectedPlanId,
      periodPlanTierPriceId: this.$store.state.backOffice.steps.periodPlanTierPriceId,
      tierId: this.$store.state.backOffice.steps.selectedTierId,
      period: this.$store.state.backOffice.steps.paymentPeriod,
      loading: false,
      hasErrorName: false,
      name: '',
      messages: [],
    }
  },

  created() {
    this.customer = this.$store.state.backOffice.steps.customer
    this.organizationId = this.$route.params.organizationId
    this.billingInfo = this.$store.state.backOffice.steps.billingInfo
    this.periodPlanTierPriceId = this.$store.state.backOffice.steps.periodPlanTierPriceId
    this.planId = this.$store.state.backOffice.steps.selectedPlanId

    if (this.$route.query.redirect_status) {
      this.createPayment()
      if (this.$route.query.planId && this.$route.query.tierId) {
        this.handleStripeRedirectPlan(this.$route.query.planId, this.$route.query.tierId)
      }
      this.$router.replace({ query: null })
      return
    }

    this.stripe = window.Stripe(this.$configs.VUE_APP_STRIPE_PK, {
      locale: this.lang.split('-')[0],
    })
  },

  mounted() {},

  destroyed() {
    if (this.card) {
      this.card.destroy(this.$refs.card)
    }
  },

  computed: {
    lang() {
      return this.$store.state.lang
    },

    options() {
      if (this.customer && this.customer.card) {
        return [
          {
            label: `**** **** **** ${this.customer.card.last4}`,
            brand: this.customer.card.brand,
            expMonth: this.customer.card.expMonth,
            expYear: this.customer.card.expYear,
            paymentMethodId: this.customer.card.id,
            iframe: false,
            key: 'oldCard',
          },
          { label: 'new payment', brand: null, iframe: true },
        ]
      }

      return [{ label: 'new payment', brand: null, iframe: true, key: 'newCard' }]
    },
  },

  methods: {
    async submit() {
      this.loading = true

      this.messages = []
      if (!this.selectedPayment.iframe && this.customer.card.last4) {
        this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'selectPayment', data: this.selectedPayment })
        this.createPayment()
        return
      }

      let result

      if (this.selectedPayment.iframe) {
        result = await this.confirmSetup()
      } else {
        result = await this.confirmCardPayment()
      }

      let errorMessage

      if (result.error) {
        switch (result.error.type) {
          case 'StripeCardError':
            // A declined card error
            console.log('error', result.error.message)
            errorMessage = result.error.message
            break
          case 'StripeRateLimitError':
            // Too many requests made to the API too quickly
            console.log('error', result.error.message)
            errorMessage = result.error.message
            break
          case 'StripeInvalidRequestError':
            // Invalid parameters were supplied to Stripe's API
            console.log('error', result.error.message)
            errorMessage = result.error.message
            break
          case 'StripeAPIError':
            // An error occurred internally with Stripe's API
            console.log('error', result.error.message)
            errorMessage = result.error.message
            break
          case 'StripeConnectionError':
            // Some kind of error occurred during the HTTPS communication
            console.log('error', result.error.message)
            errorMessage = result.error.message
            break
          case 'validation_error':
            // You probably used an incorrect API key or Your card number is incomplete
            console.log('error', result.error.message, this.$refs.card)
            errorMessage = result.error.message
            // this.hasErrorName = true
            break
          case 'invalid_request_error':
            console.log('error', result.error.message)
            errorMessage = result.error.message
            break
          case 'StripeAuthenticationError':
            // You probably used an incorrect API key
            console.log('error', result.error.message)
            errorMessage = result.error.message
            break
          case 'card_error':
            // You probably used an incorrect API key
            console.log('error', result.error.message, this.$refs.card, this.card)
            errorMessage = result.error.message
            break
          default:
            // Handle any other types of unexpected errors
            throw new Error(result)
        }

        this.messages.push({
          status: 'danger',
          text: errorMessage || 'erro',
        })

        this.loading = false
        return
      }

      this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'selectPayment', data: this.selectedPayment })
      this.$store.dispatch('backOffice/steps/setCurrentStep', 4)
      this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'maxStep', data: 4 })

      this.loading = false
    },

    focus() {
      this.hasErrorName = false
    },

    prev() {
      this.$store.dispatch('backOffice/steps/setCurrentStep', 2)
    },

    selectMethod(event) {
      this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'selectPayment', data: event })

      if (!event.iframe) {
        if (this.card) {
          this.card.destroy(this.$refs.card)
        }
        return
      }

      this.mountIframeStripe()
    },

    mountIframeStripe() {
      this.elements = this.stripe.elements({
        clientSecret: this.customer.setupSecret,
        appearance: this.appearance,
      })

      this.card = this.elements.create('payment', {
        fields: {
          billingDetails: {
            name: 'auto',
          },
        },
      })

      this.card.mount(this.$refs.card)
    },

    createPayment() {
      if (this.billingInfo.countryId == 'PT' && this.billingInfo.detailCountry === undefined) {
        let billingInfoAux = JSON.parse(JSON.stringify(this.billingInfo))
        billingInfoAux.detailCountry = 'portugal'
        this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'billingInfo', data: billingInfoAux })
        this.billingInfo = this.$store.state.backOffice.steps.billingInfo
        // Alterando a forma como esta regra foi aplicada para uma cópia e atualização do objeto
        // this.billingInfo.detailCountry = 'portugal'
      }

      this.billingInfo.name = this.billingInfo.companyName

      this.loading = true

      this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'setupIntent', data: this.$route.query.setup_intent })
      this.$store.dispatch('backOffice/steps/updateInfoPropStep', {
        prop: 'setupIntentClientSecret',
        data: this.$route.query.setup_intent_client_secret,
      })

      this.$store
        .dispatch('backOffice/steps/createPaymentIntent', {
          info: {
            billingInfo: this.billingInfo,
            planId: this.planId,
            planTierId: this.tierId,
            periodPlanTierPriceId: this.periodPlanTierPriceId,
            period: this.period,
            stripePaymentMethodId: this.selectedPayment.paymentMethodId || null,
            setupIntent: this.$route.query.setup_intent || null,
            setupIntentClientSecret: this.$route.query.setup_intent_client_secret || this.customer.setupSecret,
          },
          organizationId: this.organizationId,
        })
        .then(({ data }) => {
          // this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'selectPayment', data: this.selectedPayment })
          this.$store.commit('backOffice/steps/SET_CARD', data.card)
        })
        .catch(({ error }) => {
          this.messages.push({
            status: 'danger',
            text: error.message || 'erro',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    async confirmSetup() {
      return await this.stripe.confirmSetup({
        elements: this.elements,
        confirmParams: {
          return_url: `${this.protocol}//${this.host}${this.path}?planId=${this.$store.state.backOffice.steps.selectedPlanId}&tierId=${this.$store.state.backOffice.steps.selectedTierId}`,
          payment_method_data: {
            billing_details: {
              name: this.name,
            },
          },
        },
      })
    },

    async confirmCardPayment() {
      return await this.stripe.confirmCardPayment(this.customer.setupSecret, {
        payment_method: {
          card: this.card,
        },
      })
    },

    async handleStripeRedirectPlan(planId, tierId) {
      const response = await services.getPlansInfo(planId)
      const plansInfo = response.data.data

      const matchedPlanTier = plansInfo?.planTiers.find((planInfo) => planInfo.id == tierId)
      if (!matchedPlanTier) return

      // * * Restaura detalhes do plano perdidos durante redirect Stripe
      this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'maxAudience', data: matchedPlanTier.maxAudienceRecipients })
      this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'maxEmailsIncluded', data: matchedPlanTier.maxEmailsPerMonth })
    },
  },

  watch: {
    lang(newValue) {
      this.card = this.elements.update({ locale: newValue.split('-')[0] })
    },

    options(newValue, oldValue) {
      this.selectedPayment = newValue[0] || null
    },

    selectedPayment(newValue) {
      if (newValue.iframe) {
        this.mountIframeStripe()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-size {
  width: 200px;
  background: red;
}

#custom-button {
  height: 30px;
  outline: 1px solid grey;
  background-color: green;
  padding: 5px;
  color: white;
}

.form-group.error {
  margin-bottom: 5px !important;
}

.form-group.error input {
  border-width: 2px !important;
  border-color: #df1b41 !important;
}

form.form-group .nameCard input.form-control:focus {
  outline: 0 !important;
  border-width: 1px !important;
  border-color: #0573e180 !important;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(0, 0, 0, 0.02), 0 0 0 3px #0573e140, 0 1px 1px 0 #00000014 !important;
}

p.error {
  color: #df1b41;
}
</style>
